import { lazy } from 'react';

const TrustedDevice = lazy(() => import('./TrustedDevice'));
const SecurityCheckup = lazy(() => import('./SecurityCheckup'));
const TwoFA = lazy(() => import('./2FA'));
const DeviceSuspended = lazy(() => import('./DeviceSuspended'));

export { TrustedDevice, SecurityCheckup, TwoFA, DeviceSuspended };
